;(function($) {
    $.fn.equalHeights = function(cmd) {
        if(cmd === 'reset') {
            return this.each(function() {
                $(this).css("height","").css("overflow","");
            });
        }
        if ($(window).width() > 767) {
            var tallest = 0;
            this.each(function () {
                if ($(this).height() > tallest) {
                    tallest = $(this).height();
                }
            });
            return this.each(function () {
                $(this).height(tallest).css("overflow", "hidden");
            });
        }
    }
})(jQuery);
